import React from "react";
import {NumericFormat, NumericFormatProps} from "react-number-format";
import {InternalNumberFormatBase} from "react-number-format/types/types";

interface CustomProps {
	onChange: (event: { target: { name: string; value: string } }) => void;
	name: string;
	decimalCustom?: number;
}
const NumericFormatCustom = React.forwardRef<
	NumericFormatProps<InternalNumberFormatBase>,
	CustomProps
>(function NumericFormatCustom(props, ref) {
	const { onChange, decimalCustom = 2, ...other } = props;

	return (
		<NumericFormat
			{...other}
			getInputRef={ref}
			onValueChange={(values) => {
				// if(values.formattedValue === '0,0') {
				// 	onChange({
				// 		target: {
				// 			name: props.name,
				// 			value: values.formattedValue,
				// 		},
				// 	});
				// } else {
				// 	onChange({
				// 		target: {
				// 			name: props.name,
				// 			value: values.value,
				// 		},
				// 	});
				// }
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			allowNegative={false}
			// allowEmptyFormatting={false}
			allowLeadingZeros={false}
			thousandSeparator={" "}
			decimalSeparator=","
			decimalScale={decimalCustom}
			// fixedDecimalScale
		/>
	);
});

export default NumericFormatCustom;